export default "__VITE_ASSET__f11d2a04__"